import {Component, OnInit} from '@angular/core';
import {HeaderDataService} from '../../services/header_data.service';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {LockTemplateTableComponent} from "../lock-template-table/lock-template-table.component";

@Component({
    selector: 'lock-template-table-view',
    templateUrl: './lock-template-table-view.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        LockTemplateTableComponent
    ],
    styleUrls: ['./lock-template-table-view.component.less']
})
export class LockTemplateTableViewComponent implements OnInit {

    constructor(private headerData: HeaderDataService) {
    }

    ngOnInit(): void {
        this.buildHeader();
    }

    buildHeader() {
        this.headerData.title = 'Lock Template Tables';
        this.headerData.show_dtp = false;
    };
}
